const DELIMITER = ",";

function escapeCsvValue(value) {
    const text = String(value ?? "").replace(/\r?\n/g, " ");
    return `"${text.replace(/"/g, '""')}"`;
}

export function buildCsvFromObjects(objectRows) {
    if (!objectRows || objectRows.length === 0) return "";

    const headers = Object.keys(objectRows[0]);

    return [
        headers.map(escapeCsvValue).join(DELIMITER),
        ...objectRows.map((row) =>
            headers.map((header) => escapeCsvValue(row[header])).join(DELIMITER)
        ),
    ].join("\r\n");
}
